import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import PhotoIcon from "@material-ui/icons/Photo";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { displayAlertifyError } from "../../util/functions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      margin: 0,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
    input: {
      display: "none",
    },
  })
);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function MyCompany() {
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [items, setItems] = useState([]);
  const [company, setCompany] = useState([]);
  const [taxes, setTaxes] = useState([]);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [count, setCount] = useState(0);
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState();
  const [profile, setProfile] = useState("");
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [search, setSearch] = useState("");
  const [foundItems, setFoundItems] = useState(items);
  const [noResult, setNoResult] = useState(false);

  const [taxInfo, setTaxInfo] = useState([]);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  // const changeHandler = (event) => {
  // 	setSelectedFile(event.target.files[0]);
  // };

  const handleselectedFile = (event) => {
    setSelectedFile(event.target.files[0]);
    setSelectedFileName(event.target.files[0].name);
  };

  const handleSelect = (event) => {
    setProfile(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(host + "get-company-profile", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.data == null) {
          setCompany("");
        } else {
          setId(response.data.data.id);
          setCompany(response.data.data);
          console.log(id);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [count, host, id, token]);

  function updateProfile() {
    let name = $("#name").val();
    setName(name);
    let phone = $("#phone").val();
    setPhone(phone);
    let address = $("#address").val();
    setAddress(address);
    let city = $("#city").val();
    setCity(city);
    let state = $("#state").val();
    setState(state);
    let country = $("#country").val();
    setCountry(country);
    let zipcode = $("#zipcode").val();
    setZipcode(zipcode);

    if (name === "" || name === undefined) {
      displayAlertifyError({ error: "Please enter name" });
      return false;
    }
    if (phone === "" || phone === undefined) {
      displayAlertifyError({ error: "Please enter phone number" });
      return false;
    }
    if (address === "" || address === undefined) {
      displayAlertifyError({ error: "Please enter address" });
      return false;
    }
    if (city === "" || city === undefined) {
      displayAlertifyError({ error: "Please enter city" });
      return false;
    }
    if (state === "" || state === undefined) {
      displayAlertifyError({ error: "Please enter state" });
      return false;
    }
    if (country === "" || country === undefined) {
      displayAlertifyError({ error: "Please enter country" });
      return false;
    }
    if (zipcode === "" || zipcode === undefined) {
      displayAlertifyError({ error: "Please enter zipcode" });
      return false;
    }

    const fd = new FormData();
    if (selectedFile != null) {
      fd.append("file_url", selectedFile, selectedFile.name);
    }
    fd.append("id", id);
    fd.append("name", name);
    fd.append("phone", phone);
    fd.append("address", address);
    fd.append("city", city);
    fd.append("state", state);
    fd.append("county", country);
    fd.append("postal_code", zipcode);

    return axios
      .post(host + "update-company-profile", fd, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary pull-right mr-2"
                      onClick={() => {
                        updateProfile();
                      }}
                    >
                      Update
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="text-center pb-3">
                          <h3 style={{ fontWeight: "bold", marginTop: "10px" }}>
                            Company Details
                          </h3>
                        </div>
                        {/* <Box fontSize={20} fontWeight="bold" mb={2}>
                              Company Information
                            </Box> */}
                        <form id="create_client">
                          <div className="row">
                            <div className="col-12">
                              <div className="row">
                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      Company Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="name"
                                      name="name"
                                      required="required"
                                      autoFocus
                                      defaultValue={company.name}
                                      onChange={(e) => setName(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      Phone Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="phone"
                                      name="phone"
                                      required="required"
                                      defaultValue={company.phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      Address
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="address"
                                      name="address"
                                      required
                                      defaultValue={company.address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      City
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="city"
                                      name="city"
                                      required
                                      defaultValue={company.city}
                                      onChange={(e) => setCity(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      State
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="state"
                                      name="state"
                                      required
                                      defaultValue={company.state}
                                      onChange={(e) => setState(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="country"
                                      name="country"
                                      required
                                      defaultValue={company.county}
                                      onChange={(e) =>
                                        setCountry(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group mb-2">
                                    <label className="mdc-floating-label--shake mb-1">
                                      Zip Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="zipcode"
                                      name="zipcode"
                                      required
                                      defaultValue={company.postal_code}
                                      onChange={(e) =>
                                        setZipcode(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <b>{selectedFileName}</b>
                                  <Box m={2} ml={0}>
                                    <input
                                      accept="image/*"
                                      className={classes.input}
                                      id="contained-button-file"
                                      type="file"
                                      name="file"
                                      onChange={handleselectedFile}
                                    />
                                    <label htmlFor="contained-button-file">
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                        style={{ borderRadius: 50 }}
                                      >
                                        Upload Logo
                                        <CloudUploadIcon className="ml-2" />
                                      </Button>
                                    </label>
                                  </Box>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    {company.file_url !== null ? (
                                      <img
                                        src={company.file_url}
                                        alt="Company Logo"
                                        width={250}
                                        height={200}
                                      />
                                    ) : (
                                      <PhotoIcon style={{ fontSize: 50 }} />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default MyCompany;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
